export const topProductsAddedToWishlistDemoData = {
    "items": [
        {
            "id": 168622270,
            "sku": "b41223779c63f2a82614f5375062995a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/man-active-oversized-one-more-rep-t-shirt/BMM80340.html?color=265",
            "name": "Man Active Oversized One More Rep T-shirt",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "grey marl",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm80340_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "16.00",
            "sale_price": "11.20",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/tXYM5QgBvgdIrJexSa5A0/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/tXYM5QgBvgdIrJexSa5A0/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 27,
                    "wishlists": 197,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722700,
            "sku": "fd3ebf71f5b49caa69b0f27f6fffe21e-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-venom-license-t-shirt/BMM64125.html?color=105",
            "name": "Oversized Venom License T-shirt",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm64125_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "20.00",
            "sale_price": "14.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/aNsrr7GGwy3iZekYeWHbJ/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/aNsrr7GGwy3iZekYeWHbJ/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Belt": "no belt",
                "Color": "dark blue and navy",
                "Style": "casual",
                "Design": "picture",
                "Gender": "men",
                "Closure": "no closure",
                "Sleeves": "short sleeves",
                "Category": "Clothing/Upper",
                "Material": "cotton",
                "Neckline": "crew",
                "Subcategory": "t-shirts",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 18,
                    "wishlists": 144,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722702,
            "sku": "a4744a9b80317f2b9240ddbeacf77907-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/brushed-rib-ottoman-relaxed-split-hem-jogger/BMM62170.html?color=115",
            "name": "Brushed Rib Ottoman Relaxed Split Hem Jogger",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "charcoal",
            "openai_category": null,
            "category_id": null,
            "category": "Joggers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm62170_charcoal_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "25.00",
            "sale_price": "17.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/Y4ngkHpAtkno_wpyzr8gK/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/Y4ngkHpAtkno_wpyzr8gK/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 19,
                    "wishlists": 132,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722703,
            "sku": "f34c2be605fca817c3fb4de3959dbe70-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/faux-suede-snaffle-loafer/AMM13895.html?color=105",
            "name": "Faux Suede Snaffle Loafer",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Oxfords & loafers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/amm13895_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "40.00",
            "sale_price": "28.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/vGP3hiqrkzJ46EL-RhA6K/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/vGP3hiqrkzJ46EL-RhA6K/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 2,
                    "wishlists": 111,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622271,
            "sku": "de63c267d7e814218df7b46c4c2d375a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/relaxed-rigid-flare-frayed-edge-cargo-jeans/BMM53063.html?color=436",
            "name": "Relaxed Rigid Flare Frayed Edge Cargo Jeans",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "washed black",
            "openai_category": null,
            "category_id": null,
            "category": "Flared jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm53063_washed%20black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/qx8wqezA2SP-CpPT2PHSp/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/qx8wqezA2SP-CpPT2PHSp/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "wide leg",
                "Rise": "can't tell",
                "Color": "black",
                "Style": "sport",
                "Design": "plain",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Subcategory": "cargo",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 22,
                    "wishlists": 108,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722705,
            "sku": "fe74490bfa3f70d1431ffb66611e5861-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/relaxed-rigid-jeans/BMM52277.html?color=115",
            "name": "Relaxed Rigid Jeans",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "charcoal",
            "openai_category": null,
            "category_id": null,
            "category": "Jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm52277_charcoal_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "25.00",
            "sale_price": "17.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/AleNwz5rZla2wRaACMAJ_/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/AleNwz5rZla2wRaACMAJ_/original.jpg",
            "tags": null,
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "wide leg",
                "Rise": "low rise",
                "Color": "black",
                "Style": "casual",
                "Design": "plain",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Material": "cotton",
                "Subcategory": "casual trousers",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 25,
                    "wishlists": 98,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622272,
            "sku": "cb4aa1acf7acdabf400a7e373e57e81b-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/man-active-gym-muscle-fit-ribbed-vest/BMM32518.html?color=173",
            "name": "Man Active Gym Muscle Fit Ribbed Vest",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "white",
            "openai_category": null,
            "category_id": null,
            "category": "Vest tops",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm32518_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "12.00",
            "sale_price": "8.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_jCAaUvZMR772X-qlhm03N/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_jCAaUvZMR772X-qlhm03N/original.jpg",
            "tags": {
                "color": "white",
                "category": "tank-top",
                "attributes": [
                    {
                        "type": "neckline_type",
                        "values": [
                            {
                                "score": 0.93851,
                                "attribute": "round-neck"
                            }
                        ]
                    },
                    {
                        "type": "tank_type",
                        "values": [
                            {
                                "score": 0.99975,
                                "attribute": "sleeveless"
                            }
                        ]
                    },
                    {
                        "type": "tops_fit",
                        "values": [
                            {
                                "score": 0.82562,
                                "attribute": "bodycon-tops"
                            }
                        ]
                    },
                    {
                        "type": "tops_length",
                        "values": [
                            {
                                "score": 0.95596,
                                "attribute": "short"
                            }
                        ]
                    },
                    {
                        "type": "colors",
                        "values": [
                            {
                                "score": 0.99918,
                                "attribute": "white"
                            }
                        ]
                    },
                    {
                        "type": "pattern",
                        "values": [
                            {
                                "score": 0.34309,
                                "attribute": "horizontal-stripes"
                            }
                        ]
                    },
                    {
                        "type": "material",
                        "values": [
                            {
                                "score": 1,
                                "attribute": "cotton"
                            }
                        ]
                    },
                    {
                        "type": "style",
                        "values": [
                            {
                                "score": 0.81511,
                                "attribute": "casual"
                            }
                        ]
                    },
                    {
                        "type": "occasion",
                        "values": [
                            {
                                "score": 0.81511,
                                "attribute": "casual"
                            }
                        ]
                    }
                ]
            },
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 21,
                    "wishlists": 66,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622273,
            "sku": "97e8ebe222835aa4e30cb7e63d7ef989-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/classic-faux-leather-brogue/BMM54051.html?color=105",
            "name": "Classic Faux Leather Brogue",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Oxfords & brogues",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm54051_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "42.00",
            "sale_price": "29.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/HtqwjSX8eJGcub5kxjgFL/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/HtqwjSX8eJGcub5kxjgFL/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 4,
                    "wishlists": 64,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622275,
            "sku": "126c6187f0285b878c2bca31c6904e5f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/round-metal-sunglasses/BMM71627.html?color=105",
            "name": "Round Metal Sunglasses",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Sunglasses",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm71627_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "8.00",
            "sale_price": "5.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/iLcppLCqXTubb3OHMstr0/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/iLcppLCqXTubb3OHMstr0/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 14,
                    "wishlists": 59,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622276,
            "sku": "76403d0d812e75b8a2d4cb53f82bb22f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/slim-tapered-bonded-scuba-jogger/BMM41600.html?color=167",
            "name": "Slim Tapered Bonded Scuba Jogger",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "taupe",
            "openai_category": null,
            "category_id": null,
            "category": "Joggers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm41600_taupe_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "25.00",
            "sale_price": "17.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_tcHPGbuv0-J3eDXQGcEAg/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_tcHPGbuv0-J3eDXQGcEAg/original.jpg",
            "tags": {
                "color": "white",
                "category": "sneakers",
                "attributes": [
                    {
                        "type": "sneakers_type",
                        "values": [
                            {
                                "score": 1,
                                "attribute": "low-sneakers"
                            }
                        ]
                    },
                    {
                        "type": "heels_height",
                        "values": [
                            {
                                "score": 1,
                                "attribute": "flats"
                            }
                        ]
                    },
                    {
                        "type": "colors",
                        "values": [
                            {
                                "score": 0.99439,
                                "attribute": "white"
                            }
                        ]
                    },
                    {
                        "type": "pattern",
                        "values": [
                            {
                                "score": 0.98602,
                                "attribute": "plain"
                            }
                        ]
                    },
                    {
                        "type": "style",
                        "values": [
                            {
                                "score": 0.5,
                                "attribute": "sporty"
                            }
                        ]
                    },
                    {
                        "type": "occasion",
                        "values": [
                            {
                                "score": 0.5,
                                "attribute": "sport"
                            }
                        ]
                    }
                ]
            },
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 19,
                    "wishlists": 59,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622280,
            "sku": "08c389d8e996ffcbc7e08e7eee1bd82a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/slim-rigid-jean/BMM54663.html?color=564",
            "name": "Slim Rigid Jean",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "light blue",
            "openai_category": null,
            "category_id": null,
            "category": "Slim fit jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm54663_light%20blue_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "22.00",
            "sale_price": "15.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/wIYg_ZQp14x6myNELrksF/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/wIYg_ZQp14x6myNELrksF/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 20,
                    "wishlists": 53,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622282,
            "sku": "c3eef0a502725a83516f5af18eb31cb2-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-space-back-print-t-shirt/MZZ85077.html?color=105",
            "name": "Oversized Space Back Print T-shirt",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/mzz85077_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "14.00",
            "sale_price": "9.80",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/12kZx5CyCVLf3eMDhenN2/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/12kZx5CyCVLf3eMDhenN2/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 18,
                    "wishlists": 49,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622283,
            "sku": "483f6d717ccaa4200f5759704c54f02a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-nirvana-face-license-t-shirt/MZZ86578.html?color=173",
            "name": "Oversized Nirvana Face License T-shirt",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "white",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/mzz86578_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "22.00",
            "sale_price": "15.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 68,
                    "wishlists": 48,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 11,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622286,
            "sku": "7a7f34136a6ab5d13899e1054b68f02e-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/man-active-gym-cargo-jogger/BMM48064.html?color=265",
            "name": "Man Active Gym Cargo Jogger",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "grey marl",
            "openai_category": null,
            "category_id": null,
            "category": "Joggers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm48064_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/hF7R-U_csQyf2NYq8Purx/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/hF7R-U_csQyf2NYq8Purx/original.jpg",
            "tags": [
                {
                    "color": "gray",
                    "category": "sweatpants"
                },
                {
                    "color": "white, gray",
                    "category": "sneakers"
                },
                {
                    "color": "white",
                    "category": "sneakers"
                }
            ],
            "ximilar_tags": {
                "Age": "adult",
                "Fit": "straight",
                "Rise": "low rise",
                "Color": "grey",
                "Style": "sport",
                "Design": "melange",
                "Gender": "men",
                "Length": "long",
                "Category": "Clothing/Pants",
                "Material": "denim",
                "Subcategory": "sweat pants",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 27,
                    "wishlists": 46,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622287,
            "sku": "ba95261a564e0b659042daae3c61285e-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-boxy-puff-print-acid-wash-hoodie/BMM76699.html?color=105",
            "name": "Oversized Boxy Puff Print Acid Wash Hoodie",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Hoodies & sweatshirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm76699_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "30.00",
            "sale_price": "21.00",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/OHY1P9xl2Q7g_gn8k-uj9/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/OHY1P9xl2Q7g_gn8k-uj9/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 23,
                    "wishlists": 44,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168722708,
            "sku": "5501110d3af819509f7a9d614daf7c2f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/long-sleeve-contrast-collar-knitted-shirt-in-black/BMM75282.html?color=105",
            "name": "Long Sleeve Contrast Collar Knitted Shirt In Black",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Long-sleeved t-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm75282_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "28.00",
            "sale_price": "19.60",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-16T01:01:50.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 21,
                    "wishlists": 39,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 1,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622288,
            "sku": "a439296d9049db2da69ab4954c140b5a-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/extreme-baggy-rigid-multi-cargo-pocket-trousers/BMM75337.html?color=105",
            "name": "Extreme Baggy Rigid Multi Cargo Pocket Trousers",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "Trousers",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm75337_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "35.00",
            "sale_price": "24.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/o7eULQ2gYsDMM5M4yWa2K/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/o7eULQ2gYsDMM5M4yWa2K/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 23,
                    "wishlists": 37,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622289,
            "sku": "5e35cff8e88fdb3b6e2314b879c56b3f-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/chunky-cuban-chain-necklace/BMM14674.html?color=163",
            "name": "Chunky Cuban Chain Necklace",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "silver",
            "openai_category": null,
            "category_id": null,
            "category": "Necklaces & Pendants",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm14674_silver_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "5.00",
            "sale_price": "3.50",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/pwgDO1WtLgqIICYhBDA0g/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/pwgDO1WtLgqIICYhBDA0g/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 16,
                    "wishlists": 33,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622291,
            "sku": "b1c172c4ea7d6e2d74dbbeaa25cde0a5-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/skinny-stretch-heavy-bleached-ripped-jean/BMM51546.html?color=979",
            "name": "Skinny Stretch Heavy Bleached Ripped Jean",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "ice grey",
            "openai_category": null,
            "category_id": null,
            "category": "Ripped jeans",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/bmm51546_ice%20grey_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "32.00",
            "sale_price": "22.40",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/JJdQkMf7fddV1MZ4u-vQU/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/JJdQkMf7fddV1MZ4u-vQU/original.jpg",
            "tags": null,
            "ximilar_tags": null,
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 3,
                    "wishlists": 31,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": -1,
                        "percent": -100
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        },
        {
            "id": 168622293,
            "sku": "9b1f9e4245de30309bd946188d2e4cdf-1059",
            "excluded": 0,
            "exclude_discovery": 0,
            "retailer_feed_id": 1059,
            "link": "https://www.boohoo.com/oversized-virtues-graphic-t-shirt/AMM00817.html?color=105",
            "name": "Oversized Virtues Graphic T-shirt",
            "status": 1,
            "version": "202504031101",
            "gender": "MEN",
            "color": "black",
            "openai_category": null,
            "category_id": null,
            "category": "T-shirts",
            "original_category": null,
            "item": null,
            "external_image": "https://media.boohoo.com/i/boohoo/amm00817_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
            "price": "16.00",
            "sale_price": "11.20",
            "currency": "GBP",
            "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_QNRbf4J8OYv7TjBdgkbfW/original.jpg",
            "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_QNRbf4J8OYv7TjBdgkbfW/original.jpg",
            "tags": {
                "color": "turquoise",
                "category": "t-shirt",
                "attributes": [
                    {
                        "type": "neckline_type",
                        "values": [
                            {
                                "score": 0.28114,
                                "attribute": "round-neck"
                            }
                        ]
                    },
                    {
                        "type": "tops_fit",
                        "values": [
                            {
                                "score": 0.95615,
                                "attribute": "oversized-tops"
                            }
                        ]
                    },
                    {
                        "type": "tops_length",
                        "values": [
                            {
                                "score": 0.66946,
                                "attribute": "thigh-length"
                            }
                        ]
                    },
                    {
                        "type": "colors",
                        "values": [
                            {
                                "score": 0.61568,
                                "attribute": "turquoise"
                            }
                        ]
                    },
                    {
                        "type": "pattern",
                        "values": [
                            {
                                "score": 0.28048,
                                "attribute": "leaf"
                            }
                        ]
                    },
                    {
                        "type": "style",
                        "values": [
                            {
                                "score": 0.99902,
                                "attribute": "casual"
                            }
                        ]
                    },
                    {
                        "type": "occasion",
                        "values": [
                            {
                                "score": 0.5,
                                "attribute": "nightout"
                            }
                        ]
                    }
                ]
            },
            "ximilar_tags": {
                "Age": "adult",
                "Belt": "no belt",
                "Hood": "hood",
                "Color": "black",
                "Style": "casual",
                "Design": "picture",
                "Gender": "men",
                "Closure": "no closure",
                "Sleeves": "short sleeves",
                "Category": "Clothing/Upper",
                "Material": "cotton",
                "Neckline": "back",
                "Subcategory": "t-shirts",
                "Top Category": "Clothing"
            },
            "ximilar_category": [],
            "created_at": "2025-02-15T01:01:44.000000Z",
            "updated_at": "2025-04-03T11:01:12.000000Z",
            "blocks": null,
            "brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "feeder_brand": {
                "id": 232,
                "name": "boohooMAN"
            },
            "checked": 0,
            "excluded_category": 0,
            "stats": {
                "period": {
                    "from": "2025-04-04",
                    "to": "2025-04-04"
                },
                "totals": {
                    "views": 17,
                    "wishlists": 31,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 1,
                    "outfits": 0
                },
                "period_counts": {
                    "views": 0,
                    "wishlists": 0,
                    "price_alerts": 0,
                    "shares": 0,
                    "clicks": 0,
                    "outfits": 0
                },
                "gain": {
                    "views": {
                        "amount": 0,
                        "percent": 0
                    },
                    "wishlists": {
                        "amount": 0,
                        "percent": 0
                    },
                    "price_alerts": {
                        "amount": 0,
                        "percent": 0
                    },
                    "shares": {
                        "amount": 0,
                        "percent": 0
                    },
                    "clicks": {
                        "amount": 0,
                        "percent": 0
                    },
                    "outfits": {
                        "amount": 0,
                        "percent": 0
                    }
                }
            }
        }
    ],
    "info": {
        "current_page": "1",
        "total_pages": 32,
        "total_items": 625,
        "page_count": 20
    }
}

export const topProductsAddedToPriceAlertDemoData = {
    "items": [
      {
        "id": 168622270,
        "sku": "b41223779c63f2a82614f5375062995a-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/man-active-oversized-one-more-rep-t-shirt/BMM80340.html?color=265",
        "name": "Man Active Oversized One More Rep T-shirt",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "grey marl",
        "openai_category": null,
        "category_id": null,
        "category": "T-shirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm80340_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "16.00",
        "sale_price": "11.20",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/tXYM5QgBvgdIrJexSa5A0/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/tXYM5QgBvgdIrJexSa5A0/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 27,
            "wishlists": 0,
            "price_alerts": 246,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168722700,
        "sku": "fd3ebf71f5b49caa69b0f27f6fffe21e-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/oversized-venom-license-t-shirt/BMM64125.html?color=105",
        "name": "Oversized Venom License T-shirt",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "T-shirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm64125_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "20.00",
        "sale_price": "14.00",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/aNsrr7GGwy3iZekYeWHbJ/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/aNsrr7GGwy3iZekYeWHbJ/original.jpg",
        "tags": null,
        "ximilar_tags": {
          "Age": "adult",
          "Belt": "no belt",
          "Color": "dark blue and navy",
          "Style": "casual",
          "Design": "picture",
          "Gender": "men",
          "Closure": "no closure",
          "Sleeves": "short sleeves",
          "Category": "Clothing/Upper",
          "Material": "cotton",
          "Neckline": "crew",
          "Subcategory": "t-shirts",
          "Top Category": "Clothing"
        },
        "ximilar_category": [],
        "created_at": "2025-02-16T01:01:50.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 18,
            "wishlists": 0,
            "price_alerts": 233,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168722702,
        "sku": "a4744a9b80317f2b9240ddbeacf77907-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/brushed-rib-ottoman-relaxed-split-hem-jogger/BMM62170.html?color=115",
        "name": "Brushed Rib Ottoman Relaxed Split Hem Jogger",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "charcoal",
        "openai_category": null,
        "category_id": null,
        "category": "Joggers",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm62170_charcoal_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "25.00",
        "sale_price": "17.50",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/Y4ngkHpAtkno_wpyzr8gK/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/Y4ngkHpAtkno_wpyzr8gK/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-16T01:01:50.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 19,
            "wishlists": 0,
            "price_alerts": 214,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168722703,
        "sku": "f34c2be605fca817c3fb4de3959dbe70-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/faux-suede-snaffle-loafer/AMM13895.html?color=105",
        "name": "Faux Suede Snaffle Loafer",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "Oxfords & loafers",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/amm13895_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "40.00",
        "sale_price": "28.00",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/vGP3hiqrkzJ46EL-RhA6K/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/vGP3hiqrkzJ46EL-RhA6K/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-16T01:01:50.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 2,
            "wishlists": 0,
            "price_alerts": 199,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622271,
        "sku": "de63c267d7e814218df7b46c4c2d375a-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/relaxed-rigid-flare-frayed-edge-cargo-jeans/BMM53063.html?color=436",
        "name": "Relaxed Rigid Flare Frayed Edge Cargo Jeans",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "washed black",
        "openai_category": null,
        "category_id": null,
        "category": "Flared jeans",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm53063_washed%20black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "28.00",
        "sale_price": "19.60",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/qx8wqezA2SP-CpPT2PHSp/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/qx8wqezA2SP-CpPT2PHSp/original.jpg",
        "tags": null,
        "ximilar_tags": {
          "Age": "adult",
          "Fit": "wide leg",
          "Rise": "can't tell",
          "Color": "black",
          "Style": "sport",
          "Design": "plain",
          "Gender": "men",
          "Length": "long",
          "Category": "Clothing/Pants",
          "Subcategory": "cargo",
          "Top Category": "Clothing"
        },
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 22,
            "wishlists": 0,
            "price_alerts": 196,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168722705,
        "sku": "fe74490bfa3f70d1431ffb66611e5861-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/relaxed-rigid-jeans/BMM52277.html?color=115",
        "name": "Relaxed Rigid Jeans",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "charcoal",
        "openai_category": null,
        "category_id": null,
        "category": "Jeans",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm52277_charcoal_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "25.00",
        "sale_price": "17.50",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/AleNwz5rZla2wRaACMAJ_/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/AleNwz5rZla2wRaACMAJ_/original.jpg",
        "tags": null,
        "ximilar_tags": {
          "Age": "adult",
          "Fit": "wide leg",
          "Rise": "low rise",
          "Color": "black",
          "Style": "casual",
          "Design": "plain",
          "Gender": "men",
          "Length": "long",
          "Category": "Clothing/Pants",
          "Material": "cotton",
          "Subcategory": "casual trousers",
          "Top Category": "Clothing"
        },
        "ximilar_category": [],
        "created_at": "2025-02-16T01:01:50.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 25,
            "wishlists": 0,
            "price_alerts": 165,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622272,
        "sku": "cb4aa1acf7acdabf400a7e373e57e81b-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/man-active-gym-muscle-fit-ribbed-vest/BMM32518.html?color=173",
        "name": "Man Active Gym Muscle Fit Ribbed Vest",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "white",
        "openai_category": null,
        "category_id": null,
        "category": "Vest tops",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm32518_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "12.00",
        "sale_price": "8.40",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_jCAaUvZMR772X-qlhm03N/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_jCAaUvZMR772X-qlhm03N/original.jpg",
        "tags": {
          "color": "white",
          "category": "tank-top",
          "attributes": [
            {
              "type": "neckline_type",
              "values": [
                {
                  "score": 0.93851,
                  "attribute": "round-neck"
                }
              ]
            },
            {
              "type": "tank_type",
              "values": [
                {
                  "score": 0.99975,
                  "attribute": "sleeveless"
                }
              ]
            },
            {
              "type": "tops_fit",
              "values": [
                {
                  "score": 0.82562,
                  "attribute": "bodycon-tops"
                }
              ]
            },
            {
              "type": "tops_length",
              "values": [
                {
                  "score": 0.95596,
                  "attribute": "short"
                }
              ]
            },
            {
              "type": "colors",
              "values": [
                {
                  "score": 0.99918,
                  "attribute": "white"
                }
              ]
            },
            {
              "type": "pattern",
              "values": [
                {
                  "score": 0.34309,
                  "attribute": "horizontal-stripes"
                }
              ]
            },
            {
              "type": "material",
              "values": [
                {
                  "score": 1,
                  "attribute": "cotton"
                }
              ]
            },
            {
              "type": "style",
              "values": [
                {
                  "score": 0.81511,
                  "attribute": "casual"
                }
              ]
            },
            {
              "type": "occasion",
              "values": [
                {
                  "score": 0.81511,
                  "attribute": "casual"
                }
              ]
            }
          ]
        },
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 21,
            "wishlists": 0,
            "price_alerts": 143,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622273,
        "sku": "97e8ebe222835aa4e30cb7e63d7ef989-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/classic-faux-leather-brogue/BMM54051.html?color=105",
        "name": "Classic Faux Leather Brogue",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "Oxfords & brogues",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm54051_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "42.00",
        "sale_price": "29.40",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/HtqwjSX8eJGcub5kxjgFL/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/HtqwjSX8eJGcub5kxjgFL/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 4,
            "wishlists": 0,
            "price_alerts": 141,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622275,
        "sku": "126c6187f0285b878c2bca31c6904e5f-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/round-metal-sunglasses/BMM71627.html?color=105",
        "name": "Round Metal Sunglasses",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "Sunglasses",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm71627_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "8.00",
        "sale_price": "5.60",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/iLcppLCqXTubb3OHMstr0/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/iLcppLCqXTubb3OHMstr0/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 14,
            "wishlists": 0,
            "price_alerts": 135,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622276,
        "sku": "76403d0d812e75b8a2d4cb53f82bb22f-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/slim-tapered-bonded-scuba-jogger/BMM41600.html?color=167",
        "name": "Slim Tapered Bonded Scuba Jogger",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "taupe",
        "openai_category": null,
        "category_id": null,
        "category": "Joggers",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm41600_taupe_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "25.00",
        "sale_price": "17.50",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_tcHPGbuv0-J3eDXQGcEAg/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_tcHPGbuv0-J3eDXQGcEAg/original.jpg",
        "tags": {
          "color": "white",
          "category": "sneakers",
          "attributes": [
            {
              "type": "sneakers_type",
              "values": [
                {
                  "score": 1,
                  "attribute": "low-sneakers"
                }
              ]
            },
            {
              "type": "heels_height",
              "values": [
                {
                  "score": 1,
                  "attribute": "flats"
                }
              ]
            },
            {
              "type": "colors",
              "values": [
                {
                  "score": 0.99439,
                  "attribute": "white"
                }
              ]
            },
            {
              "type": "pattern",
              "values": [
                {
                  "score": 0.98602,
                  "attribute": "plain"
                }
              ]
            },
            {
              "type": "style",
              "values": [
                {
                  "score": 0.5,
                  "attribute": "sporty"
                }
              ]
            },
            {
              "type": "occasion",
              "values": [
                {
                  "score": 0.5,
                  "attribute": "sport"
                }
              ]
            }
          ]
        },
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 19,
            "wishlists": 0,
            "price_alerts": 133,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622280,
        "sku": "08c389d8e996ffcbc7e08e7eee1bd82a-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/slim-rigid-jean/BMM54663.html?color=564",
        "name": "Slim Rigid Jean",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "light blue",
        "openai_category": null,
        "category_id": null,
        "category": "Slim fit jeans",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm54663_light%20blue_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "22.00",
        "sale_price": "15.40",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/wIYg_ZQp14x6myNELrksF/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/wIYg_ZQp14x6myNELrksF/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 20,
            "wishlists": 0,
            "price_alerts": 124,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622282,
        "sku": "c3eef0a502725a83516f5af18eb31cb2-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/oversized-space-back-print-t-shirt/MZZ85077.html?color=105",
        "name": "Oversized Space Back Print T-shirt",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "T-shirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/mzz85077_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "14.00",
        "sale_price": "9.80",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/12kZx5CyCVLf3eMDhenN2/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/12kZx5CyCVLf3eMDhenN2/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 18,
            "wishlists": 0,
            "price_alerts": 111,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622283,
        "sku": "483f6d717ccaa4200f5759704c54f02a-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/oversized-nirvana-face-license-t-shirt/MZZ86578.html?color=173",
        "name": "Oversized Nirvana Face License T-shirt",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "white",
        "openai_category": null,
        "category_id": null,
        "category": "T-shirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/mzz86578_white_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "22.00",
        "sale_price": "15.40",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/MLz0JA6qf8Ni3zw-xd3oB/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 68,
            "wishlists": 0,
            "price_alerts": 106,
            "shares": 0,
            "clicks": 11,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622286,
        "sku": "7a7f34136a6ab5d13899e1054b68f02e-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/man-active-gym-cargo-jogger/BMM48064.html?color=265",
        "name": "Man Active Gym Cargo Jogger",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "grey marl",
        "openai_category": null,
        "category_id": null,
        "category": "Joggers",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm48064_grey%20marl_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "28.00",
        "sale_price": "19.60",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/hF7R-U_csQyf2NYq8Purx/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/hF7R-U_csQyf2NYq8Purx/original.jpg",
        "tags": [
          {
            "color": "gray",
            "category": "sweatpants"
          },
          {
            "color": "white, gray",
            "category": "sneakers"
          },
          {
            "color": "white",
            "category": "sneakers"
          }
        ],
        "ximilar_tags": {
          "Age": "adult",
          "Fit": "straight",
          "Rise": "low rise",
          "Color": "grey",
          "Style": "sport",
          "Design": "melange",
          "Gender": "men",
          "Length": "long",
          "Category": "Clothing/Pants",
          "Material": "denim",
          "Subcategory": "sweat pants",
          "Top Category": "Clothing"
        },
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 27,
            "wishlists": 0,
            "price_alerts": 104,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622287,
        "sku": "ba95261a564e0b659042daae3c61285e-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/oversized-boxy-puff-print-acid-wash-hoodie/BMM76699.html?color=105",
        "name": "Oversized Boxy Puff Print Acid Wash Hoodie",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "Hoodies & sweatshirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm76699_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "30.00",
        "sale_price": "21.00",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/OHY1P9xl2Q7g_gn8k-uj9/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/OHY1P9xl2Q7g_gn8k-uj9/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 23,
            "wishlists": 0,
            "price_alerts": 99,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168722708,
        "sku": "5501110d3af819509f7a9d614daf7c2f-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/long-sleeve-contrast-collar-knitted-shirt-in-black/BMM75282.html?color=105",
        "name": "Long Sleeve Contrast Collar Knitted Shirt In Black",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "Long-sleeved t-shirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm75282_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "28.00",
        "sale_price": "19.60",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/xl42oHM-deOJZ0ccthSMv/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-16T01:01:50.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 21,
            "wishlists": 0,
            "price_alerts": 87,
            "shares": 0,
            "clicks": 1,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622288,
        "sku": "a439296d9049db2da69ab4954c140b5a-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/extreme-baggy-rigid-multi-cargo-pocket-trousers/BMM75337.html?color=105",
        "name": "Extreme Baggy Rigid Multi Cargo Pocket Trousers",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "Trousers",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm75337_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "35.00",
        "sale_price": "24.50",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/o7eULQ2gYsDMM5M4yWa2K/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/o7eULQ2gYsDMM5M4yWa2K/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 23,
            "wishlists": 0,
            "price_alerts": 86,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622289,
        "sku": "5e35cff8e88fdb3b6e2314b879c56b3f-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/chunky-cuban-chain-necklace/BMM14674.html?color=163",
        "name": "Chunky Cuban Chain Necklace",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "silver",
        "openai_category": null,
        "category_id": null,
        "category": "Necklaces & Pendants",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm14674_silver_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "5.00",
        "sale_price": "3.50",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/pwgDO1WtLgqIICYhBDA0g/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/pwgDO1WtLgqIICYhBDA0g/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 16,
            "wishlists": 0,
            "price_alerts": 81,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622291,
        "sku": "b1c172c4ea7d6e2d74dbbeaa25cde0a5-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/skinny-stretch-heavy-bleached-ripped-jean/BMM51546.html?color=979",
        "name": "Skinny Stretch Heavy Bleached Ripped Jean",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "ice grey",
        "openai_category": null,
        "category_id": null,
        "category": "Ripped jeans",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/bmm51546_ice%20grey_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "32.00",
        "sale_price": "22.40",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/JJdQkMf7fddV1MZ4u-vQU/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/JJdQkMf7fddV1MZ4u-vQU/original.jpg",
        "tags": null,
        "ximilar_tags": null,
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 3,
            "wishlists": 0,
            "price_alerts": 77,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": -1,
              "percent": -100
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      },
      {
        "id": 168622293,
        "sku": "9b1f9e4245de30309bd946188d2e4cdf-1059",
        "excluded": 0,
        "exclude_discovery": 0,
        "retailer_feed_id": 1059,
        "link": "https://www.boohoo.com/oversized-virtues-graphic-t-shirt/AMM00817.html?color=105",
        "name": "Oversized Virtues Graphic T-shirt",
        "status": 1,
        "version": "202504031101",
        "gender": "MEN",
        "color": "black",
        "openai_category": null,
        "category_id": null,
        "category": "T-shirts",
        "original_category": null,
        "item": null,
        "external_image": "https://media.boohoo.com/i/boohoo/amm00817_black_xl?w=900&qlt=default&fmt.jp2.qlt=70&fmt=auto&sm=fit",
        "price": "16.00",
        "sale_price": "11.20",
        "currency": "GBP",
        "image": "https://d2sl3ai4g6turs.cloudfront.net/feed/_QNRbf4J8OYv7TjBdgkbfW/original.jpg",
        "img": "https://d2sl3ai4g6turs.cloudfront.net/feed/_QNRbf4J8OYv7TjBdgkbfW/original.jpg",
        "tags": {
          "color": "turquoise",
          "category": "t-shirt",
          "attributes": [
            {
              "type": "neckline_type",
              "values": [
                {
                  "score": 0.28114,
                  "attribute": "round-neck"
                }
              ]
            },
            {
              "type": "tops_fit",
              "values": [
                {
                  "score": 0.95615,
                  "attribute": "oversized-tops"
                }
              ]
            },
            {
              "type": "tops_length",
              "values": [
                {
                  "score": 0.66946,
                  "attribute": "thigh-length"
                }
              ]
            },
            {
              "type": "colors",
              "values": [
                {
                  "score": 0.61568,
                  "attribute": "turquoise"
                }
              ]
            },
            {
              "type": "pattern",
              "values": [
                {
                  "score": 0.28048,
                  "attribute": "leaf"
                }
              ]
            },
            {
              "type": "style",
              "values": [
                {
                  "score": 0.99902,
                  "attribute": "casual"
                }
              ]
            },
            {
              "type": "occasion",
              "values": [
                {
                  "score": 0.5,
                  "attribute": "nightout"
                }
              ]
            }
          ]
        },
        "ximilar_tags": {
          "Age": "adult",
          "Belt": "no belt",
          "Hood": "hood",
          "Color": "black",
          "Style": "casual",
          "Design": "picture",
          "Gender": "men",
          "Closure": "no closure",
          "Sleeves": "short sleeves",
          "Category": "Clothing/Upper",
          "Material": "cotton",
          "Neckline": "back",
          "Subcategory": "t-shirts",
          "Top Category": "Clothing"
        },
        "ximilar_category": [],
        "created_at": "2025-02-15T01:01:44.000000Z",
        "updated_at": "2025-04-03T11:01:12.000000Z",
        "blocks": null,
        "brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "feeder_brand": {
          "id": 232,
          "name": "boohooMAN"
        },
        "checked": 0,
        "excluded_category": 0,
        "stats": {
          "period": {
            "from": "2025-04-04",
            "to": "2025-04-04"
          },
          "totals": {
            "views": 17,
            "wishlists": 0,
            "price_alerts": 66,
            "shares": 0,
            "clicks": 1,
            "outfits": 0
          },
          "period_counts": {
            "views": 0,
            "wishlists": 0,
            "price_alerts": 0,
            "shares": 0,
            "clicks": 0,
            "outfits": 0
          },
          "gain": {
            "views": {
              "amount": 0,
              "percent": 0
            },
            "wishlists": {
              "amount": 0,
              "percent": 0
            },
            "price_alerts": {
              "amount": 0,
              "percent": 0
            },
            "shares": {
              "amount": 0,
              "percent": 0
            },
            "clicks": {
              "amount": 0,
              "percent": 0
            },
            "outfits": {
              "amount": 0,
              "percent": 0
            }
          }
        }
      }
    ],
    "info": {
      "current_page": "1",
      "total_pages": 32,
      "total_items": 625,
      "page_count": 20
    }
  }

  export const topSearchedPhrasesDemoData = {
    "period": {
        "to": "2025-04-04",
        "from": "2025-03-28"
    },
    "stats": [
        {
            "phrase": "boohoo",
            "count": 250,
            "result_count": 1203.5
        },
        {
            "phrase": "boohoo red dress",
            "count": 220,
            "result_count": 1
        },
        {
            "phrase": "boohoo rib legging",
            "count": 140,
            "result_count": 67
        },
        {
            "phrase": "boohoo denim jacket",
            "count": 132,
            "result_count": 17
        },
        {
            "phrase": "boohoo flared jeans",
            "count": 111,
            "result_count": 11
        },
        {
            "phrase": "boohoo jacket",
            "count": 77,
            "result_count": 119
        },
        {
            "phrase": "boohoo jacket denim",
            "count": 45,
            "result_count": 17
        },
        {
            "phrase": "boohoo red skirt",
            "count": 34,
            "result_count": 3
        }
    ]
}

export const topShoppingFiltersDemoData = {
    "period": {
        "to": "2025-04-04",
        "from": "2025-03-28"
    },
    "place": "SHOPPING",
    "stats": [
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": null,
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 890,
            "result_count": 3468
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 788,
            "result_count": 2234
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 673,
            "result_count": 1597
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 567,
            "result_count": 1333
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 444,
            "result_count": 190
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 432,
            "result_count": 244
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 420,
            "result_count": 55
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 365,
            "result_count": 53
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 332,
            "result_count": 965
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "SHOPPING"
                ]
            },
            "count": 115,
            "result_count": 766
        }
    ]
}

export const topMarketplaceFiltersDemoData = {
    "period": {
        "to": "2025-04-04",
        "from": "2025-03-28"
    },
    "place": "MARKETPLACE",
    "stats": [
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": [
                    "Sandals"
                ],
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 115,
            "result_count": 634
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 112,
            "result_count": 621
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": null,
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 96,
            "result_count": 780
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": [
                    "Ripped jeans",
                    "Sandals"
                ],
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 89,
            "result_count": 32
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 81,
            "result_count": 93
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 77,
            "result_count": 1
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 74,
            "result_count": 124
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 68,
            "result_count": 117
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 65,
            "result_count": 55
        },
        {
            "filters": {
                "gender": [
                    "Men"
                ],
                "brands": [
                    "boohooMAN"
                ],
                "colors": [
                    "Red"
                ],
                "categories": null,
                "phrase": null,
                "place": [
                    "MARKETPLACE"
                ]
            },
            "count": 44,
            "result_count": 75
        },
    ]
}

export const entrancesToShopFromShoppingDemoData = {
    "type": "month",
    "field": "shop_nows",
    "stats": [
        {
            "period": {
                "from": "2025-01-01",
                "to": "2025-01-31"
            },
            "value": 637
        },
        {
            "period": {
                "from": "2025-02-01",
                "to": "2025-02-28"
            },
            "value": 774
        },
        {
            "period": {
                "from": "2025-03-01",
                "to": "2025-03-31"
            },
            "value": 652
        },
        {
            "period": {
                "from": "2025-04-01",
                "to": "2025-04-30"
            },
            "value": 863
        }
    ]
}

export const wishlistedStatsDemoData = {
    "type": "month",
    "field": "wishlists",
    "stats": [
        {
            "period": {
                "from": "2025-01-01",
                "to": "2025-01-31"
            },
            "value": 435
        },
        {
            "period": {
                "from": "2025-02-01",
                "to": "2025-02-28"
            },
            "value": 363
        },
        {
            "period": {
                "from": "2025-03-01",
                "to": "2025-03-31"
            },
            "value": 333
        },
        {
            "period": {
                "from": "2025-04-01",
                "to": "2025-04-30"
            },
            "value": 465
        }
    ]
}

export const priceAlertsStatsDemoData = {
    "type": "month",
    "field": "price_alerts",
    "stats": [
        {
            "period": {
                "from": "2025-01-01",
                "to": "2025-01-31"
            },
            "value": 99
        },
        {
            "period": {
                "from": "2025-02-01",
                "to": "2025-02-28"
            },
            "value": 112
        },
        {
            "period": {
                "from": "2025-03-01",
                "to": "2025-03-31"
            },
            "value": 74
        },
        {
            "period": {
                "from": "2025-04-01",
                "to": "2025-04-30"
            },
            "value": 110
        }
    ]
}